import {ComponentFactoryResolver, NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {adminPanelRoutes} from './admin-panel.routes';
import {UserContentComponent} from './components/user-content/user-content.component';
import {CommonModule} from '@angular/common';
import {AdminPanelCellDecoratorComponent} from './components/cell-decorators/admin-panel-cell-decorator/admin-panel-cell-decorator.component';
import {AdminPanelApiService} from './services/admin-panel-api.service';
import {EffectsModule} from '@ngrx/effects';
import {AdminPanelEffect} from './store/effects/admin-panel.effect';
import {StoreModule} from '@ngrx/store';
import {adminPanelReducer} from './store/reducers/admin-panel.reducer';
import {AddUserComponent} from './components/add-user/add-user.component';
import {UpdateUserComponent} from './components/update-user/update-user.component';
import {AddSolutionComponent} from './components/add-solution/add-solution.component';
import {DetailUserComponent} from './components/detail-user/detail-user.component';
import {CompanyContentComponent} from './components/company-content/company-content.component';
import {AddCompanyComponent} from './components/add-company/add-company.component';
import {DetailCompanyComponent} from './components/detail-company/detail-company.component';
import {CompanyIdCellViewerComponent} from './components/cell-viewers/company-id-cell-viewer/company-id-cell-viewer.component';
import {UpdateCompanyComponent} from './components/update-company/update-company.component';
import {EmailCellViewerComponent} from './components/cell-viewers/email-cell-viewer/email-cell-viewer.component';
import {UpdateSolutionComponent} from './components/update-solution/update-solution.component';
import {CloneUserComponent} from './components/clone-user/clone-user.component';
import { CreateSupportTicketComponent } from './components/create-support-ticket/create-support-ticket.component';
import { SendPasswordComponent } from './components/send-password/send-password.component';
import {SharedModule} from '@shared/shared.module';
import {ParticleService} from '@core/services/particle.service';
import { DataFactoryComponent } from './components/data-factory/data-factory.component';
import {CommandService} from '@core/services/command.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {adminPanelLinkCommands} from './admin-panel.link-commands';
import {AdminPanelDynamicComponentHelper} from '@features/admin-panel/admin-panel-dynamic-component-helper';
import {PlatformToolDataFactoryHandler} from '@features/admin-panel/services/platform-tool-data-factory-handler';
import { EmailBlastRecipientDialogDefEditorComponent } from './components/dialog-definition-editors/email-blast-recipient-dialog-def-editor/email-blast-recipient-dialog-def-editor.component';
import { EmailBlastDetailDialogDefEditorComponent } from './components/dialog-definition-editors/email-blast-detail-dialog-def-editor/email-blast-detail-dialog-def-editor.component';
import {PlatformToolEmailBlastHandler} from '@features/admin-panel/platform-tool-handlers/platform-tool-email-blast-handler';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatChipsModule} from '@angular/material/chips';
import {MatInputModule} from '@angular/material/input';
import {DialogDefinitionDynamicHtmlEditorComponent} from '@features/admin-panel/components/dialog-definition-dynamic-html-editor/dialog-definition-dynamic-html-editor.component';
import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import { MapCompanyComponent } from './components/map-company/map-company.component';
import {AdminPanelHandler} from '@features/admin-panel/platform-tool-handlers/admin-panel-handler';
import { MapCompanyCellViewerComponent } from './components/map-company-cell-viewer/map-company-cell-viewer.component';
import {PlatformToolSandboxHandler} from '@features/admin-panel/platform-tool-handlers/platform-tool-sandbox-handler';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {UserListRolesCellViewerComponent} from '@features/admin-panel/components/user-company-roles-cell-viewer/user-list-roles-cell-viewer.component';
import { AdminPanelPartnerCompanyHandler } from './platform-tool-handlers/admin-panel-partner-company-handler';
import { AdminPanelCompanyHandler } from './platform-tool-handlers/admin-panel-company-handler';
import { AdminPanelCompanyDetailHandler } from './platform-tool-handlers/admin-panel-company-detail-handler';
import { AdminPanelCompanyDetailFormComponent } from './components/admin-panel-company-detail-form/admin-panel-company-detail-form.component';
import { AdminPanelCompanyUserListComponent } from './components/admin-panel-company-user-list/admin-panel-company-user-list.component';
import { AdminPanelUserDetailHandler } from './platform-tool-handlers/admin-panel-user-detail-handler';
import { AdminPanelUserDetailFormComponent } from './components/admin-panel-user-detail-form/admin-panel-user-detail-form.component';
import { AdminPanelUserPackageListComponent } from './components/admin-panel-user-package-list/admin-panel-user-package-list.component';
import { AdminPanelUserDetailLinkComponent } from './components/admin-panel-user-detail-link/admin-panel-user-detail-link.component';
import {PlatformApiProvider} from '@shared/services/platform-api-provider';
import {PlatformToolRfpHandler} from '@features/admin-panel/platform-tool-handlers/platform-tool-rfp-handler';
import {AdminDashboardComponent} from './components/admin-dashboard/admin-dashboard.component';
import {AdminDashboardKpiTileComponent} from './components/admin-dashboard/kpi-tile/admin-dashboard-kpi-tile.component';
import {AdminDashboardSparklineComponent} from './components/admin-dashboard/sparkline/admin-dashboard-sparkline.component';
import {AdminDashboardPeriodPickerComponent} from './components/admin-dashboard/period-picker/admin-dashboard-period-picker.component';
import {AdminDashboardFilterBarComponent} from './components/admin-dashboard/filter-bar/admin-dashboard-filter-bar.component';
import {AdminDashboardExpiryTimelineComponent} from './components/admin-dashboard/expiry-timeline/admin-dashboard-expiry-timeline.component';
import {AdminDashboardXatBotQualityComponent} from './components/admin-dashboard/xatbot-quality/admin-dashboard-xatbot-quality.component';
import {AdminDashboardFailingTopicsComponent} from './components/admin-dashboard/failing-topics/admin-dashboard-failing-topics.component';
import {AdminDashboardInitFailuresComponent} from './components/admin-dashboard/init-failures/admin-dashboard-init-failures.component';
import {AdminDashboardTrialsEndingComponent} from './components/admin-dashboard/trials-ending/admin-dashboard-trials-ending.component';
import {AdminDashboardBillingThisMonthComponent} from './components/admin-dashboard/billing-this-month/admin-dashboard-billing-this-month.component';
import {AdminDashboardApiKeysExpiringComponent} from './components/admin-dashboard/api-keys-expiring/admin-dashboard-api-keys-expiring.component';
import {AdminDashboardRevenueCoverageComponent} from './components/admin-dashboard/revenue-coverage/admin-dashboard-revenue-coverage.component';
import {AdminDashboardScopeSwitchComponent} from './components/admin-dashboard/scope-switch/admin-dashboard-scope-switch.component';
import {AdminDashboardNonClientListComponent} from './components/admin-dashboard/nonclient-list/admin-dashboard-nonclient-list.component';
import {AdminDashboardAttentionComponent} from './components/admin-dashboard/attention/admin-dashboard-attention.component';
import {AdminDashboardSpendBarsComponent} from './components/admin-dashboard/spend-bars/admin-dashboard-spend-bars.component';
import {AdminDashboardWhyPanelComponent} from './components/admin-dashboard/why-panel/admin-dashboard-why-panel.component';
import {AdminDashboardCompany360Component} from './components/admin-dashboard/company-360/admin-dashboard-company-360.component';
import {AdminDashboardC360TimelineComponent} from './components/admin-dashboard/company-360/timeline/admin-dashboard-c360-timeline.component';
import {AdminDashboardC360EngagementComponent} from './components/admin-dashboard/company-360/engagement/admin-dashboard-c360-engagement.component';
import {AdminDashboardC360CommercialComponent} from './components/admin-dashboard/company-360/commercial/admin-dashboard-c360-commercial.component';
import {AdminDashboardC360RenewalHistoryComponent} from './components/admin-dashboard/company-360/renewal-history/admin-dashboard-c360-renewal-history.component';
import {AdminDashboardC360ProductUseComponent} from './components/admin-dashboard/company-360/product-use/admin-dashboard-c360-product-use.component';
import {AdminDashboardLoginsPerDayComponent} from './components/admin-dashboard/logins-per-day/admin-dashboard-logins-per-day.component';
import {AdminDashboardSignupsPerWeekComponent} from './components/admin-dashboard/signups-per-week/admin-dashboard-signups-per-week.component';
import {AdminDashboardActivityRankingComponent} from './components/admin-dashboard/activity-ranking/admin-dashboard-activity-ranking.component';
import {AdminDashboardSeatUtilisationComponent} from './components/admin-dashboard/seat-utilisation/admin-dashboard-seat-utilisation.component';
import {AdminDashboardCohortRetentionComponent} from './components/admin-dashboard/cohort-retention/admin-dashboard-cohort-retention.component';
import {AdminDashboardTrialFunnelComponent} from './components/admin-dashboard/trial-funnel/admin-dashboard-trial-funnel.component';
import {AdminDashboardSettingsComponent} from './components/admin-dashboard/settings/admin-dashboard-settings.component';
import {AdminDashboardSettingsImpactComponent} from './components/admin-dashboard/settings/impact/admin-dashboard-settings-impact.component';
import {AdminDashboardCountPipe} from './helpers/admin-dashboard-count.pipe';
import {AdminDashboardEmptyComponent} from './components/admin-dashboard/empty/admin-dashboard-empty.component';
import {AdminDashboardDrillDialogComponent} from './components/admin-dashboard/drill/admin-dashboard-drill-dialog.component';
import {AdminDashboardSeasonalLoadComponent} from './components/admin-dashboard/seasonal-load/admin-dashboard-seasonal-load.component';
import {AdminDashboardActivationFunnelComponent} from './components/admin-dashboard/activation-funnel/admin-dashboard-activation-funnel.component';
import {AdminDashboardEntityHeadroomComponent} from './components/admin-dashboard/entity-headroom/admin-dashboard-entity-headroom.component';
import {AdminDashboardUsageActivityComponent} from './components/admin-dashboard/usage-activity/admin-dashboard-usage-activity.component';
import {AdminDashboardEntitiesTrendComponent} from './components/admin-dashboard/entities-trend/admin-dashboard-entities-trend.component';
import {AdminDashboardScenariosTrendComponent} from './components/admin-dashboard/scenarios-trend/admin-dashboard-scenarios-trend.component';
import {AdminDashboardProjectsTrendComponent} from './components/admin-dashboard/projects-trend/admin-dashboard-projects-trend.component';
import {AdminDashboardCompaniesComponent} from './components/admin-dashboard/companies/admin-dashboard-companies.component';
import {MatSelectModule} from '@angular/material/select';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@NgModule({
  declarations: [
    UserContentComponent,
    AdminPanelCellDecoratorComponent,
    AddUserComponent,
    UpdateUserComponent,
    AddSolutionComponent,
    DetailUserComponent,
    CompanyContentComponent,
    AddCompanyComponent,
    DetailCompanyComponent,
    CompanyIdCellViewerComponent,
    UpdateCompanyComponent,
    EmailCellViewerComponent,
    UpdateSolutionComponent,
    CloneUserComponent,
    CreateSupportTicketComponent,
    SendPasswordComponent,
    DataFactoryComponent,
    EmailBlastRecipientDialogDefEditorComponent,
    EmailBlastDetailDialogDefEditorComponent,
    DialogDefinitionDynamicHtmlEditorComponent,
    MapCompanyComponent,
    MapCompanyCellViewerComponent,
    UserListRolesCellViewerComponent,
    AdminPanelCompanyDetailFormComponent,
    AdminPanelCompanyUserListComponent,
    AdminPanelUserDetailFormComponent,
    AdminPanelUserPackageListComponent,
    AdminPanelUserDetailLinkComponent,
    AdminDashboardComponent,
    AdminDashboardKpiTileComponent,
    AdminDashboardSparklineComponent,
    AdminDashboardPeriodPickerComponent,
    AdminDashboardFilterBarComponent,
    AdminDashboardExpiryTimelineComponent,
    AdminDashboardXatBotQualityComponent,
    AdminDashboardFailingTopicsComponent,
    AdminDashboardInitFailuresComponent,
    AdminDashboardTrialsEndingComponent,
    AdminDashboardBillingThisMonthComponent,
    AdminDashboardApiKeysExpiringComponent,
    AdminDashboardRevenueCoverageComponent,
    AdminDashboardScopeSwitchComponent,
    AdminDashboardNonClientListComponent,
    AdminDashboardAttentionComponent,
    AdminDashboardSpendBarsComponent,
    AdminDashboardWhyPanelComponent,
    AdminDashboardCompany360Component,
    AdminDashboardC360TimelineComponent,
    AdminDashboardC360EngagementComponent,
    AdminDashboardC360CommercialComponent,
    AdminDashboardC360RenewalHistoryComponent,
    AdminDashboardC360ProductUseComponent,
    AdminDashboardLoginsPerDayComponent,
    AdminDashboardSignupsPerWeekComponent,
    AdminDashboardActivityRankingComponent,
    AdminDashboardSeatUtilisationComponent,
    AdminDashboardCohortRetentionComponent,
    AdminDashboardTrialFunnelComponent,
    AdminDashboardSettingsComponent,
    AdminDashboardSettingsImpactComponent,
    AdminDashboardCountPipe,
    AdminDashboardEmptyComponent,
    AdminDashboardDrillDialogComponent,
    AdminDashboardSeasonalLoadComponent,
    AdminDashboardActivationFunnelComponent,
    AdminDashboardEntityHeadroomComponent,
    AdminDashboardUsageActivityComponent,
    AdminDashboardEntitiesTrendComponent,
    AdminDashboardScenariosTrendComponent,
    AdminDashboardProjectsTrendComponent,
    AdminDashboardCompaniesComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(adminPanelRoutes),
    StoreModule.forFeature('admin-panel', adminPanelReducer),
    EffectsModule.forFeature([AdminPanelEffect]),
    MatAutocompleteModule,
    MatChipsModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    ClipboardModule
  ],
  providers: [AdminPanelApiService],
  exports: [
  ]
})
export class AdminPanelModule {
  constructor(private particleService: ParticleService,
              private commandService: CommandService,
              private platformToolEmailBlastHandler: PlatformToolEmailBlastHandler,
              private platformToolSandboxHandler: PlatformToolSandboxHandler,
              private adminPanelHandler: AdminPanelHandler,
              private adminPanelPartnerCompanyHandler: AdminPanelPartnerCompanyHandler,
              private adminPanelCompanyHandler: AdminPanelCompanyHandler,
              private adminPanelCompanyDetailHandler: AdminPanelCompanyDetailHandler,
              private adminPanelUserDetailHandler: AdminPanelUserDetailHandler,
              private dataFactoryHandler: PlatformToolDataFactoryHandler,
              private platformToolRfpHandler: PlatformToolRfpHandler,
              private platformApiProvider: PlatformApiProvider,
              private componentFactoryResolver: ComponentFactoryResolver) {
    RootDynamicComponentHelper.registerComponentFactoryResolver(this.componentFactoryResolver);
    AdminPanelDynamicComponentHelper.init();

    this.platformApiProvider.registerDefault('AdminPanelApi', '/admin-panel');

    this.particleService.registerCellComponent('AdminPanelCellDecorator', AdminPanelCellDecoratorComponent);
    this.particleService.registerCellComponent('CompanyIdCellViewer', CompanyIdCellViewerComponent);
    this.particleService.registerCellComponent('EmailCellViewer', EmailCellViewerComponent);
    AdminPanelDynamicComponentHelper.register('PlatformToolDataFactoryHandler', dataFactoryHandler);
    AdminPanelDynamicComponentHelper.register('PlatformToolEmailBlastHandler', platformToolEmailBlastHandler);
    AdminPanelDynamicComponentHelper.register('AdminPanelHandler', adminPanelHandler);
    AdminPanelDynamicComponentHelper.register('PlatformToolRfpHandler', platformToolRfpHandler);
    AdminPanelDynamicComponentHelper.register('AdminPanelPartnerCompanyHandler', adminPanelPartnerCompanyHandler);
    AdminPanelDynamicComponentHelper.register('AdminPanelCompanyHandler', adminPanelCompanyHandler);
    AdminPanelDynamicComponentHelper.register('AdminPanelCompanyDetailHandler', adminPanelCompanyDetailHandler);
    AdminPanelDynamicComponentHelper.register('AdminPanelUserDetailHandler', adminPanelUserDetailHandler);
    AdminPanelDynamicComponentHelper.register('PlatformToolSandboxHandler', platformToolSandboxHandler);
    //
    // Every AdminPanel platform-link registration lives in `adminPanelLinkCommands`, so
    // `admin-panel.routes.spec.ts` can hold each one to a route without constructing this module.
    adminPanelLinkCommands.forEach(def => {
      const linkCommand = new PlatformCommand(def.command, def.api);
      if (def.values) {
        Object.keys(def.values).forEach(key => linkCommand.setValue(key, def.values[key]));
      }
      this.commandService.registrPlatformLinkCommand(def.url, linkCommand);
    });
  }
}
